if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
        });
      }
      
    }

    changeSlide(direction) {

      if ( direction == 'next' ) {
        this.index = (this.index + 1) % this.length;
      } else if ( direction == 'prev' ) {
        this.index = (this.index - 1 + this.length) % this.length;
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}